import React, { useState } from "react";
import { Button } from "@mui/material";
import AccidentNotesDialog from "../AccidentNotesDialog/AccidentNotesDialog";

interface NotesButtonProps {
  accidentId: string;
}

const NotesButton: React.FC<NotesButtonProps> = ({ accidentId }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button variant="outlined" size="small" onClick={() => setOpen(true)}>
        Notes
      </Button>
      <AccidentNotesDialog
        open={open}
        onClose={() => setOpen(false)}
        accidentId={accidentId}
      />
    </>
  );
};

export default NotesButton;
